module.exports = __webpack_public_path__ + "img/33fb8d1.png";